var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.redirectTo }}},[_c('img',{staticClass:"mr-5",attrs:{"alt":"app logo","height":"70","width":"70","src":_vm.logoSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }